import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import axios from "axios";
import moment from "moment";
import { splitTeacherCourses } from "@/utils/teacherCourseSeparator";

import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      searchStr: "",
      teacherList: [],
      oriTeacherList: [],
      teacherIndex: 0,
      // 设置单价弹窗
      showSetFee: false,
      colorOptions: ["#ff6086", "#2651ff", "#fd9f02", "#09bd3c", "#007bff"],
      lightColor: {
        "#ff6086": "#ffedf0",
        "#2651ff": "#e4e9ff",
        "#fd9f02": "#fff4e4",
        "#09bd3c": "#e2f2e6",
        "#007bff": "#e2f1ff"
      },
      courseIndex: 0,
      showAddCourseType: false,
      // courseTypes: ["一对一", "一对二", "班课"],
      courseTypes: JSON.parse(sessionStorage.getItem("courseTypeOptions")),
      selectedCourseTypes: [],
      feeEffectiveStart: moment().format("YYYY-MM-DD"),
      feeEffectiveEnd: moment().format("YYYY-MM-DD"),
      feeStartUnlimited: false,
      feeEndUnlimited: false,
      feeVersions: []
    };
  },
  async mounted() {
    console.log("\nEnter page /teacherFee");

    // 初始化时显示固定列
    this.$refs.fixedColumn.style.display = "block";

    // 添加滚轮事件监听器，将滚动事件转发给滚动区域
    this.$refs.fixedColumn.addEventListener("wheel", this.handleFixedColumnWheel);
    await this.getTeacherList();
  },
  beforeUnmount() {
    // 清理事件监听器
    if (this.$refs.fixedColumn) {
      this.$refs.fixedColumn.removeEventListener("wheel", this.handleFixedColumnWheel);
    }
  },
  methods: {
    //获取老师列表(筛选出启用的)
    async getTeacherList() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution,
          flag: "onlyActive" //(筛选出启用的)
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherAndCourse/getTeacherList", params);
        if (resp1.data.code == "0000") {
          this.teacherList = resp1.data.data;
          for (let i in this.teacherList) {
            this.teacherList[i].courses = splitTeacherCourses(this.teacherList[i].coursesStr);

            //科目 单价
            if (!this.teacherList[i].courseTypeFee) {
              this.teacherList[i].courseTypeFee = {};
            } else {
              this.teacherList[i].courseTypeFee = JSON.parse(this.teacherList[i].courseTypeFee);
            }
          }

          // console.log("获取老师列表:", this.teacherList);
          // for (let i in this.teacherList) {
          //   if (this.teacherList[i].id == 40) {
          //     console.log("courseTypeFee:", this.teacherList[i].courseTypeFee);
          //   }
          // }

          await this.loadFeeData(this.feeEffectiveStart);
          this.oriTeacherList = JSON.parse(JSON.stringify(this.teacherList));
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    async loadFeeData(effectiveDate) {
      const resp = await axios.post("https://backend.wonology.com/courseArrange/teacherFee/getFeeData", {
        institution: this.institution,
        effectiveDate: effectiveDate
      });
      if (resp.data.code != "0000") {
        throw new Error(resp.data.msg);
      }
      this.feeVersions = resp.data.data.versions || [];
      const currentFees = resp.data.data.currentFees || {};
      for (const teacher of this.teacherList) {
        teacher.courseTypeFee = JSON.parse(JSON.stringify(currentFees[teacher.id] || {}));
      }
    },
    async feeEffectiveDateChange() {
      if (!this.feeEffectiveStart || this.feeStartUnlimited) return;
      await this.loadFeeData(this.feeEffectiveStart);
    },
    async feeBoundaryChange() {
      if (this.feeStartUnlimited) {
        await this.loadFeeData(moment().format("YYYY-MM-DD"));
      } else if (this.feeEffectiveStart) {
        await this.loadFeeData(this.feeEffectiveStart);
      }
    },
    getFeeHistory(teacherId, course, courseType) {
      return this.feeVersions.filter(item => String(item.teacherId) === String(teacherId) && item.course === course && item.courseType === courseType);
    },
    getCourseFeeHistory(teacherId, course) {
      return this.feeVersions.filter(item => String(item.teacherId) === String(teacherId) && item.course === course);
    },
    search() {
      this.teacherList = [];
      for (let teacherIndex in this.oriTeacherList) {
        let teacherName = this.oriTeacherList[teacherIndex].name;
        if (teacherName.includes(this.searchStr)) {
          this.teacherList.push(this.oriTeacherList[teacherIndex]);
        }
      }
    },
    //列表横纵滚动
    handleScroll(event) {
      const scrollTop = event.target.scrollTop;

      // 移动固定列
      this.$refs.fixedColumn.style.transform = `translateY(-${scrollTop}px)`;
    },
    // 处理固定列上的滚轮事件，将其转发给滚动区域
    handleFixedColumnWheel(event) {
      // 阻止默认行为
      event.preventDefault();

      // 获取滚动区域元素
      const scrollArea = document.getElementById("scrollArea");
      if (scrollArea) {
        // 将滚动事件转发给滚动区域
        scrollArea.scrollTop += event.deltaY;
      }
    },
    async setSelectWidth() {
      await this.$nextTick();

      // 下拉框 弹框 宽度设置
      let selectDropdownElement = document.querySelectorAll(".el-select-dropdown");
      console.log("selectDropdownElement:", selectDropdownElement);
      for (let element of selectDropdownElement) {
        // 取消下拉框 弹框 minWidth属性，使下拉框宽度自适应
        element.style.minWidth = "";

        // 设置下拉框 弹框 最大高度，超过滚动
        // element.style.maxHeight = "100px";
        element.style.overflowY = "auto";
      }
    },
    // 点击老师名 选择老师
    chooseTeacher(index) {
      this.teacherIndex = index;
    },
    //设置单价
    setFee() {
      //默认每个科目都展示一对一，一对二，班课三种类型（现在不用了）
      // for (
      //   let i = 0;
      //   i < this.teacherList[this.teacherIndex].courses.length;
      //   i++
      // ) {
      //   let course = this.teacherList[this.teacherIndex].courses[i];

      //   // 如果科目没有，直接初始化每个类型
      //   if (!this.teacherList[this.teacherIndex].courseTypeFee[course]) {
      //     this.teacherList[this.teacherIndex].courseTypeFee[course] = {};

      //     for (let j = 0; j < this.courseTypes.length; j++) {
      //       this.teacherList[this.teacherIndex].courseTypeFee[course][
      //         this.courseTypes[j]
      //       ] = "";
      //     }
      //   }
      //   // 如果科目有
      //   else {
      //     for (let j = 0; j < this.courseTypes.length; j++) {
      //       // 没内容的类型，初始化
      //       if (
      //         !this.teacherList[this.teacherIndex].courseTypeFee[course][
      //           this.courseTypes[j]
      //         ]
      //       ) {
      //         this.teacherList[this.teacherIndex].courseTypeFee[course][
      //           this.courseTypes[j]
      //         ] = "";
      //       }
      //     }
      //   }
      // }

      const today = moment().format("YYYY-MM-DD");
      this.feeEffectiveStart = today;
      this.feeEffectiveEnd = today;
      this.feeStartUnlimited = false;
      this.feeEndUnlimited = false;
      this.loadFeeData(today).then(() => {
        this.showSetFee = true;
      }).catch(error => {
        alert(error.message);
      });
    },
    async saveFeeSetting() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (!this.feeStartUnlimited && !this.feeEffectiveStart || !this.feeEndUnlimited && !this.feeEffectiveEnd) {
          alert("请选择单价生效起止日期");
          return;
        }

        //检查是否有科目的班级类型的单价没填
        //每个课程
        for (let course in this.teacherList[this.teacherIndex].courseTypeFee) {
          for (let courseType in this.teacherList[this.teacherIndex].courseTypeFee[course]) {
            const fee = this.teacherList[this.teacherIndex].courseTypeFee[course][courseType];
            if (fee === "" || fee === null || fee === undefined || !Number.isFinite(Number(fee)) || Number(fee) < 0) {
              alert(`请填写'${course}'科目'${courseType}'班级类型的有效单价`);
              return;
            }
          }
        }
        let params = {
          teacherId: this.teacherList[this.teacherIndex].id,
          courseTypeFee: this.teacherList[this.teacherIndex].courseTypeFee,
          effectiveStart: this.feeStartUnlimited ? null : this.feeEffectiveStart,
          effectiveEnd: this.feeEndUnlimited ? null : this.feeEffectiveEnd,
          startUnlimited: this.feeStartUnlimited,
          endUnlimited: this.feeEndUnlimited,
          username: sessionStorage.getItem("username")
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherFee/setFee", params);
        if (resp1.data.code == "0000") {
          this.feeVersions = resp1.data.data.versions || [];
          const today = moment().format("YYYY-MM-DD");
          this.feeEffectiveStart = today;
          this.feeEffectiveEnd = today;
          this.feeStartUnlimited = false;
          this.feeEndUnlimited = false;
          await this.loadFeeData(today);
          this.oriTeacherList = JSON.parse(JSON.stringify(this.teacherList));
          this.showSetFee = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    async cancelFeeSetting() {
      const today = moment().format("YYYY-MM-DD");
      this.feeEffectiveStart = today;
      this.feeEffectiveEnd = today;
      this.feeStartUnlimited = false;
      this.feeEndUnlimited = false;
      await this.loadFeeData(today);
      this.showSetFee = false;
    },
    //选择课程颜色
    chooseColor(index, index2) {
      // 每个课程初始已对应不同颜色
      return;
      this.teacherList[this.teacherIndex].courseColor[index] = this.colorOptions[index2];
    },
    //添加班级类型
    addCourseType(index) {
      this.courseIndex = index;
      this.selectedCourseTypes = [];
      const course = this.teacherList[this.teacherIndex].courses[index];
      if (!this.teacherList[this.teacherIndex].courseTypeFee[course]) {
        this.teacherList[this.teacherIndex].courseTypeFee[course] = {};
      }
      this.showAddCourseType = true;
      this.setSelectWidth();
    },
    async addCourseTypeConfirm() {
      let course = this.teacherList[this.teacherIndex].courses[this.courseIndex];
      if (!this.teacherList[this.teacherIndex].courseTypeFee[course]) {
        this.teacherList[this.teacherIndex].courseTypeFee[course] = {};
      }

      // 新增的班级类型
      let addCourseTypes = [];
      for (let i = 0; i < this.selectedCourseTypes.length; i++) {
        this.teacherList[this.teacherIndex].courseTypeFee[course][this.selectedCourseTypes[i]] = "";
        if (!this.courseTypes.includes(this.selectedCourseTypes[i])) {
          addCourseTypes.push(this.selectedCourseTypes[i]);
        }
      }

      // 如果有新增的班级类型，调用后端接口新增
      if (addCourseTypes.length > 0) {
        let params = {
          institution: this.institution,
          addCourseTypes: addCourseTypes
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherFee/addCourseType", params);
        if (resp1.data.code == "0000") {
          this.courseTypes = resp1.data.data;
          // 更新sessionStorage
          sessionStorage.setItem("courseTypeOptions", JSON.stringify(this.courseTypes));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      }
      this.showAddCourseType = false;
    },
    addCourseTypeCancel() {
      this.showAddCourseType = false;
    },
    //删除科目的类型
    async deleteCourseType(index, index2) {
      let course = this.teacherList[this.teacherIndex].courses[index];
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        const params = {
          teacherId: this.teacherList[this.teacherIndex].id,
          course: course,
          courseType: index2
        };
        const resp1 = await axios.post("https://backend.wonology.com/courseArrange/teacherFee/checkDeleteFee", params);
        if (resp1.data.code != "0000") {
          alert("调用后端出错: " + resp1.data.msg);
          return;
        }
        if (!resp1.data.canDelete) {
          alert(resp1.data.msg);
          return;
        }
        delete this.teacherList[this.teacherIndex].courseTypeFee[course][index2];
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    }
  }
};